<!-- 作品收益 -->
<template>
  <div class="works-profit">
    <cs-form label-width="90px" class="header-search-box padding-t-20" ref="validForm"
      form-width="100%"
      :form="searchParams"
      :formData="searchData"
      :inline="true">
      <template slot="categoryTime">
        <el-date-picker
          @change="formChange"
          v-model="categoryTime"
          type="daterange"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </template>
      <template slot="search">
        <el-button type="primary" @click="search">查 询</el-button>
      </template>
      <template slot="export">
        <el-button type="primary" @click="exportfn()">作品收益报表导出</el-button>
      </template>
    </cs-form>
    <cs-table ref="multipleTable" :tableCols="tableCols" :tableData="tableData"
      class="no-shadow-table"
      :paginationOption="paginationOption"
      @size-change="sizeChangeHandler"
      @current-change="currentPageHandler"
      :show-overflow-tooltip="false"
      >
      <template slot-scope="scope" slot="recommendplays">
           <el-button @click="openDialog(scope.row,'recommendplays')">{{scope.row.recommendplays}}</el-button>
      </template>
      <template slot-scope="scope" slot="normalplays">
           <el-button @click="openDialog(scope.row,'normalplays')">{{scope.row.normalplays}}</el-button>
      </template>
      <template slot-scope="scope" slot="playCount">
           <el-button @click="openDialog(scope.row,'playCount')">{{scope.row.playCount}}</el-button>
      </template>
      <template slot-scope="scope" slot="playTime">
           <el-button @click="openDialog(scope.row,'playTime')">{{scope.row.playTime}}</el-button>
      </template>
      <template slot-scope="scope" slot="playTimeProportion">
           <el-button @click="openDialog(scope.row,'playTimeProportion')">{{scope.row.playTimeProportion}}</el-button>
      </template>
      <template slot-scope="scope" slot="playDoneProportion">
           <el-button @click="openDialog(scope.row,'playDoneProportion')">{{scope.row.playDoneProportion}}</el-button>
      </template>
    </cs-table>
        <PlayStatisticsDialog ref="playStatisticsDialog" :dialogData='dialogData'></PlayStatisticsDialog>
  </div>
</template>
<script>
import PlayStatisticsDialog from '@/views/common/dialog/program-group-playStatistics.vue'// 播放统计dialog
import { programIncome } from '@/resource/api/ugcIndex.js'

export default {
  components: {
    PlayStatisticsDialog
  },
  data () {
    return {
      searchParams: {
        programsetName: '',
        programsetId: '',
        programName: '',
        programId: '',
        charge: '',
        startTime: '',
        endTime: '',
        pageSize: 20,
        pageNo: 1,
        stageName: this.$store.state.router.anchorId
      },
      categoryTime: [],
      pickerMinDate: '',
      defaultDate: [
        new Date(new Date(new Date().toLocaleDateString()).getTime() - 7 * 24 * 60 * 60 * 1000).getTime(),
        new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).getTime()
      ],
      // pickerOptions: {
      //   onPick: (obj) => {
      //     this.pickerMinDate = new Date(obj.minDate).getTime()
      //   },
      //   disabledDate: (time) => {
      //     if (this.pickerMinDate) {
      //       const day1 = 30 * 24 * 3600 * 1000
      //       const maxTime = this.pickerMinDate + day1
      //       const minTime = this.pickerMinDate - day1
      //       return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 0 * 24 * 3600 * 1000
      //     } else {
      //       return time.getTime() > Date.now() + 0 * 24 * 3600 * 1000
      //     }
      //   }
      // },
      tableCols: [
        { prop: 'xh', label: '序号', type: '', width: 50, sortable: true },
        { prop: 'areaName', label: '区域', type: '' },
        { prop: 'programsetId', label: '专辑ID', type: '' },
        { prop: 'programsetName', label: '专辑名称', type: '' },
        { prop: 'programId', label: '作品ID', type: '' },
        { prop: 'programName', label: '作品名称', type: '' },
        { prop: 'charge', label: '免费/付费', type: '' },
        { prop: 'recommendplays', label: '推荐播放量/次', type: 'slot' },
        { prop: 'normalplays', label: '普通播放量/次', type: 'slot' },
        { prop: 'playCount', label: '获利播放量/次', type: 'slot' },
        { prop: 'playTime', label: '播放时长', type: 'slot', width: 120 },
        { prop: 'playTimeProportion', label: '次均播放时长', type: 'slot' },
        { prop: 'playDoneProportion', label: '完播比', type: 'slot' },
        { prop: 'publishTime', label: '发布时间', type: '' }
      ],
      tableData: [],
      paginationOption: {},
      dialogData: {}
    }
  },
  mounted () {
    this.pageInit()
  },
  methods: {
    pageInit () {
      this.searchParams.startTime = this.defaultDate[0]
      this.searchParams.endTime = this.defaultDate[1]
      this.categoryTime = [this.searchParams.startTime, this.searchParams.endTime]
      this.getData(this.searchParams)
    },
    // 初始化列表
    async getData () {
      try {
        const res = await programIncome({ ...this.searchParams })
        if (res.code == 1) {
          this.tableData = res.results
          this.tableData.forEach((item, index) => {
            item.xh = index + 1 + (this.searchParams.pageNo - 1) * this.searchParams.pageSize
          })
          this.paginationOption = {
            'total': res.total,
            'page-size': this.searchParams.pageSize,
            'current-page': this.searchParams.pageNo
          }
        }
      } catch (e) {
        console.log(e, 333)
        // this.$message.error(JSON.stringify(e))
      }
    },
    // 选择时间
    formChange (timeArr) {
      if (timeArr === null) {
        this.searchParams.startTime = ''
        this.searchParams.endTime = ''
      } else {
        this.searchParams.startTime = timeArr[0]
        this.searchParams.endTime = timeArr[1]
      }
    },
    // 查询
    search () {
      this.currentPageHandler(1)
    },
    // 导出
    exportfn () {
      const objData = {
        programsetName: this.searchParams.programsetName,
        programsetId: this.searchParams.programsetId,
        programName: this.searchParams.programName,
        programId: this.searchParams.programId,
        charge: this.searchParams.charge,
        startTime: this.searchParams.startTime,
        endTime: this.searchParams.endTime,
        areaCode: 'cn',
        stageName: this.$store.state.router.anchorId
      }
      // window.location.href = process.env.VUE_APP_BASE_API_MGR + `/programIncomeExport?charge=${this.searchParams.charge}&endTime=${this.searchParams.endTime}&programId=${this.searchParams.programId}&programName=${this.searchParams.programName}&programsetId=${this.searchParams.programsetId}&programsetName=${this.searchParams.programsetName}&startTime=${this.searchParams.startTime}`
      this.$axios({
        // 跨域设置---------------------start
        async: true,
        crossDomain: true,
        withCredentials: true,
        headers: {
          AJAX: true,
          'Content-Type': 'application/json;charset=UTF-8'
        },
        // 跨域设置---------------------end
        method: 'POST',
        url: '/exportApi/api/v2/iugcOpstat/interface/outer/vod/dashbord/program/stage/download',
        // url: 'http://58.214.17.66:5307/api/v2/iugcOpstat/interface/outer/vod/dashbord/program/stage/download',
        data: JSON.stringify(objData),
        responseType: 'blob',
        timeout: 1000 * 60 * 3
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })

        const fileName = '作品收益报表导出_' + this.$moment(new Date()).format('YYYYMMDDHHmmss') +
            '.xls'
        const linkNode = document.createElement('a')

        linkNode.download = fileName // a标签的download属性规定下载文件的名称
        linkNode.style.display = 'none'
        linkNode.href = URL.createObjectURL(blob) // 生成一个Blob URL
        document.body.appendChild(linkNode)
        linkNode.click() // 模拟在按钮上的一次鼠标单击

        URL.revokeObjectURL(linkNode.href) // 释放URL 对象
        document.body.removeChild(linkNode)
      }).catch(err => {
        if (err.response && err.response.status == 601) {
          this.$message({
            type: 'error',
            message: '暂无数据可导出'
          })
        } else {
          this.$message({
            type: 'error',
            message: '程序异常'
          })
        }
      })
    },

    sizeChangeHandler (val) {
      this.searchParams.pageSize = val
      this.searchParams.pageNo = 1
      this.getData(this.searchParams)
    },
    currentPageHandler (val) {
      this.searchParams.pageNo = val
      this.searchParams.pageSize = 20
      this.getData(this.searchParams)
    },
    // 打开统计图
    openDialog (row, statisticsFields) {
      this.$refs.playStatisticsDialog.open()
      this.dialogData = {
        objData: row,
        limit: 'Y',
        statisticsFields: statisticsFields,
        categoryTime: this.categoryTime
      }
    }
  },
  computed: {
    searchData () {
      return [
        {
          prop: 'programsetName',
          type: 'input',
          label: '',
          placeholder: '请输入专辑名称',
          clearable: true,
          labelWidth: '60px'
        },
        {
          prop: 'programsetId',
          type: 'input',
          label: '',
          placeholder: '请输入专辑ID',
          clearable: true,
          labelWidth: '60px'
        },
        {
          prop: 'programName',
          type: 'input',
          label: '',
          placeholder: '请输入作品名称',
          clearable: true,
          labelWidth: '60px'
        },
        {
          prop: 'programId',
          type: 'input',
          label: '',
          placeholder: '请输入作品ID',
          clearable: true,
          labelWidth: '60px'
        },
        {
          prop: 'charge',
          label: '',
          type: 'select',
          placeholder: '请选择付费/免费',
          filterable: true,
          clearable: true,
          options: [
            { label: '付费', value: 'Y' },
            { label: '免费', value: 'N' }
          ]
        },
        { prop: 'categoryTime', type: 'slot', label: '' },
        { prop: 'search', type: 'slot', label: '' },
        { prop: 'export', type: 'slot', label: '' }
      ]
    }
  }
}
</script>
<style lang="less">
</style>
